<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <PackageDetail slot-scope="{data}" :form-data="data"></PackageDetail>
  </l-cache>
</template>
<script>
  import PackageDetail from "./packageDetail";
  export default {
    name: 'packageDetailBox',
    components: {PackageDetail},
    methods: {
      async getItem (key) {
        let {items} = await this.$store.dispatch('iot/getPackageList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        if(items.length===0){
          this.$L.alert('error',{message:'未查询到该程序包'})
          return {}
        }else{
          return items[0]
        }
      }
    }
  }
</script>
